<template>
  <div class="document">
    <cep-remove-address-modal
      :stateStudentId = "modalId"
      v-if="showModal"
      @closeModal="toggleModal"
      @removeStudent="removeStudent"
    />
    <div class="card-container">
      <div class="card-title-container">
        <div class="columns is-mobile fullwidth">
          <div class="column">
            <div class="column-container align-left">
              <div class="match-icon">
                <es-near-match/>
              </div>
              <div class="block">
                <div class="has-text-grey">
                  Eligible Address
                </div>
                <div class="has-text-weight-bold" style="font-size:14px">
                  {{ match.eligable.street1 }} {{ match.eligable.street2 }}
                </div>
                <div class="has-text-weight-bold" style="font-size:14px">
                  {{ match.eligable.city }},
                  {{ match.eligable.stateCode }}
                  {{ match.eligable.zip }}
                </div>
              </div>
            </div>
          </div>
          <div class="column">
            <div class="column-container align-left">
              <div class="block">
                <div class="has-text-grey">
                  Matched Address
                </div>
                <div class="has-text-weight-bold" style="font-size:14px">
                  {{ match.matched.street1 }} {{ match.matched.street2 }}
                </div>
                <div class="has-text-weight-bold" style="font-size:14px">
                  {{ match.matched.city }},
                  {{ match.matched.stateCode }}
                  {{ match.matched.zip }}
                </div>
              </div>
            </div>
          </div>
             <div class="column">
              <div class="column-container align-left">
                <div class="block">
                  <div>Prson Type:</div>
                  <div>Match Type:</div>      
                </div>
                  <div class="block">
                    <div class="has-text-weight-bold"> {{ match.personType }}</div>
                    <div class="has-text-weight-bold">{{ match.matchType }}</div>
                </div>
              </div>
           </div>
          <div class="column has-border" v-if="match.percent !== null">
            <div class="column-container">
              <div class="block percent-match">
                <vc-donut
                  v-if="match.percent === 100"
                  :size="60"
                  :sections="[
                  { value: match.percent, color: '#215E97' }]"
                >
                  <h1 class="percent-label">{{ match.percent }}%</h1>
                </vc-donut>
                <vc-donut
                  v-else
                  :size="60"
                  :sections="[
                  { value: match.percent - 1, color: '#215E97' },
                  { value: 1, color: '#FFFFFF' },
                  { value: 99 - match.percent, color: '#C8C8C8'},
                  { value: 1, color: '#FFFFFF' },]"
                >
                  <h1 class="percent-label">{{ match.percent }}%</h1>
                </vc-donut>
              </div>
              <div class="block">
                <div class="has-text-grey-darker">
                  <div>Match</div>
                  <div>Score</div>
                </div>
              </div>
            </div>
          </div>
          <div class="column is-2 has-border">
            <div class="column-container">
              <div class="block percent-match">
                <span class="is-black percent is-size-3 has-text-weight-bold">
                  {{ match.studentsEligible }}
                </span>
              </div>
              <div class="block">
                <div class="has-text-grey-darker">
                  <div style="width: 0px;">Students</div>
                  <div>Potentially Eligible</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="column-icons has-border is-1">
          <div class="column-container actions">
              <font-awesome-icon v-if="!isExpanded"
                style="font-size: 1.5rem; color:#544F9C"
                class="is-primary icon-spacing icon"
                @click="toggleExpand"
                :icon="['far', 'caret-down']" size="lg"
                title="View Details"/>
              <font-awesome-icon v-else
                style="font-size: 1.5rem; color:#544F9C"
                class="is-primary icon-spacing icon"
                @click="toggleExpand"
                :icon="['far', 'caret-up']" size="lg"
                title="Hide Details"/>
              <font-awesome-icon
                v-if="hasModule('DRMCH:MATCH:RESOLVENM:NOMATCH')"
                style="color:#544F9C"
                class="is-primary icon-spacing icon"
                @click="toggleModal()"
                :icon="['far', 'ban']" size="lg"
                title="Click to remove Student(s) from matching"/>
              <font-awesome-icon
                v-if="hasModule('DRMCH:MATCH:RESOLVENM:MATCHDEC')"
                style="font-size: 1.4rem; color:#544F9C"
                class="is-primary icon has-text-weight-bold"
                @click="matchStudent()"
                :icon="['far', 'check']" size="lg"
                title="Click to match Student(s) at Matched address"/>
          </div>
        </div>
      </div>
    </div>
    <div v-if="isExpanded" class="students-block">
      <template>
        <div class="is-flex students-header has-text-weight-bold has-text-grey-dark">
          <font-awesome-icon :icon="['fas', 'user-check']" size="lg" style="margin-right: 1rem"/>
          <span class="">
            Identified Student at Eligible Address
          </span>
        </div>
        <table class="table is-fullwidth is-hoverable">
          <thead>
            <tr>
              <th  style="width: 20%">Student Name</th>
              <th style="width: 20%">{{ getFieldLabel(`PER:${defaultPersonType}:DIRECTMATCH:DISTRICT_CODE`) }}</th>
              <th style="width: 20%">{{ getFieldLabel(`PER:${defaultPersonType}:DIRECTMATCH:SCHOOL_CODE`) }}</th>
              <th style="width: 10%">{{ getFieldLabel(`PER:${defaultPersonType}:DIRECTMATCH:GRADE_CODE`) }}</th>
              <th style="width: 10%">{{ getFieldLabel(`PER:${defaultPersonType}:DIRECTMATCH:GENDER_CODE`) }}</th>
              <th style="width: 10%">{{ getFieldLabel(`PER:${defaultPersonType}:DIRECTMATCH:DATE_OF_BIRTH`) }}</th>
              <th style="width: 10%">Identified Date</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>
                <span class="has-text-weight-bold">
                  {{ match.eligable.firstName }} {{ match.eligable.lastName}}
                </span>
                <span class="has-text-grey is-italic">
                  {{ match.eligable.stateStudentId }}
                </span>
              </td>
              <td>
                <span>{{ match.districtName }}</span>
                <span class="has-text-grey is-italic">({{ match.eligable.districtCode }})</span>
              </td>
              <td>
                <span>{{ match.schoolName }}</span>
                <span class="has-text-grey is-italic">({{ match.eligable.schoolCode }})</span>
              </td>
              <td>{{ match.eligable.gradeCode }}</td>
              <td>{{ mapGender(match.eligable.genderCode) }}</td>
              <td>{{ match.eligable.dateOfBirth | formatDate }}</td>
              <td>{{ match.identifiedDate | formatDate }}</td>
            </tr>
          </tbody>
        </table>
      </template>
      <template>
        <div class="is-flex students-header">
          <font-awesome-icon :icon="['fas', 'users']" size="lg" style="margin-right: 1rem"/>
          <span class="has-text-weight-bold has-text-grey-dark">
            Student(s) Currently Not Identified at Matched Address
          </span>
        </div>
        <table class="table is-fullwidth is-hoverable">
          <thead>
            <tr>
              <th  style="width: 20%">Student Name</th>
              <th style="width: 20%">{{ getFieldLabel(`PER:${defaultPersonType}:DIRECTMATCH:DISTRICT_CODE`) }}</th>
              <th style="width: 20%">{{ getFieldLabel(`PER:${defaultPersonType}:DIRECTMATCH:SCHOOL_CODE`) }}</th>
              <th style="width: 10%">{{ getFieldLabel(`PER:${defaultPersonType}:DIRECTMATCH:GRADE_CODE`) }}</th>
              <th style="width: 10%">{{ getFieldLabel(`PER:${defaultPersonType}:DIRECTMATCH:GENDER_CODE`) }}</th>
              <th style="width: 10%">{{ getFieldLabel(`PER:${defaultPersonType}:DIRECTMATCH:DATE_OF_BIRTH`) }}</th>
              <th class="has-text-right" style="width: 10%">Actions</th>
            </tr>
          </thead>
          <tbody v-for="student in match.students" :key="student.stateStudentId">
            <tr>
              <td>
                <span class="has-text-weight-bold">
                  {{ student.name}}
                </span>
                <span class="has-text-grey is-italic">
                  {{ student.stateStudentId }}
                </span>
              </td>
              <td>
                <span>{{ student.district.name }} </span>
                <span class="has-text-grey is-italic">({{ student.district.code }})</span>
              </td>
              <td>
                <span>{{ student.school.name }} </span>
                <span class="has-text-grey is-italic">({{ student.school.code }})</span>
              </td>
              <td>{{ student.grade }}</td>
              <td>{{ student.gender }}</td>
              <td>{{ student.dob | formatDate }}</td>
              <td class="has-text-right">
                <font-awesome-icon
                  v-if="hasModule('DRMCH:MATCH:RESOLVENM:NOMATCH')"
                  style="color:#544F9C"
                  class="is-primary icon icon-spacing"
                  @click="toggleModal(student.stateStudentId)"
                  :icon="['far', 'ban']" size="lg"
                  title="Click to remove Student from matching"/>
                <font-awesome-icon
                  v-if="hasModule('DRMCH:MATCH:RESOLVENM:MATCHDEC')"
                  style="font-size: 1.4rem; color:#544F9C"
                  class="is-primary icon"
                  @click="matchStudent(student.stateStudentId)"
                  :icon="['far', 'check']" size="lg"
                  title="Click to match Student at Matched address"/>
              </td>
            </tr>
          </tbody>
        </table>
      </template>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import axios from 'axios';
import moment from 'moment';
import { mapGetters, mapActions } from 'vuex';
import { library } from '@fortawesome/fontawesome-svg-core';
import Donut from 'vue-css-donut-chart';
import 'vue-css-donut-chart/dist/vcdonut.css';
import {
  faBan,
  faCaretDown,
  faCaretUp,
  faCheck,
} from '@fortawesome/pro-regular-svg-icons';
import {
  faUserCheck,
  faUsers,
} from '@fortawesome/pro-solid-svg-icons';
import CepRemoveAddressModal from '@/components/CepRemoveAddressModal.vue';
import EsMatch from '@/components/EsMatch.vue';
import EsNearMatch from '@/components/EsNearMatch.vue';
import EsNotEligable from '@/components/EsNotEligable.vue';
import NotificationManager from '@/mixins/NotificationManager';
import PermissionManager from '@/mixins/PermissionManager';
import FieldLabels from '@/mixins/FieldLabels';

library.add(
  faBan,
  faCaretDown,
  faCaretUp,
  faCheck,
  faUserCheck,
  faUsers,
);

Vue.use(Donut);

export default {
  mixins: [
    NotificationManager,
    PermissionManager,
    FieldLabels,
  ],
  components: {
    CepRemoveAddressModal,
    EsMatch,
    EsNearMatch,
    EsNotEligable,
  },
  props: ['match'],
  data() {
    return {
      isExpanded: false,
      showModal: false,
      modalId: null,
      studentIdsToMarkAsMatches: null,
      studentIdsToMarkAsNoMatches: null,
    };
  },
  async created() {
    await this.loadPersonTypes();
  },
  computed: {
    ...mapGetters('lookups', [
      'activeGenders',
      'activeGrades',
      'defaultPersonType',
    ]),
  },
  methods: {
    ...mapActions('lookups', [
      'loadPersonTypes',
    ]),
    toggleExpand() {
      this.isExpanded = !this.isExpanded;
    },
    toggleModal(id) {
      this.modalId = id;
      this.showModal = !this.showModal;
    },
    mapGender(genderCode) {
      return this.activeGenders.find(gender => gender.code === genderCode).description;
    },
    mapGrades(gradeCode) {
      return this.activeGrades.find(grade => grade.code === gradeCode).description;
    },
    async matchStudent(stateStudentId) {
      this.studentIdsToMarkAsMatches = stateStudentId
        ? [stateStudentId] : [...this.match.students.map(s => s.stateStudentId)];
      try {
        await axios.put(`/directmatch/address/pending/${this.match.id}`, ({
          matchTypeId: this.matchTypeId,
          studentIdsToMarkAsMatches: this.studentIdsToMarkAsMatches,
          command: 'MARK_IDS',
        }));
        this.showNotification('success', ['The person(s) at Matched Address are matched successfully.']);
      } catch (error) {
        const { status } = error.response;
        let apiMsg = '';

        if (status === 500) {
          apiMsg = 'Network Error';
        } else if (status === 400) {
          apiMsg = 'Something went wrong.';
        } else {
          apiMsg = `${error.response.data.message}`;
        }
        this.showNotification('danger', [apiMsg]);
      }
      this.$emit('refresh');
    },
    async removeStudent(stateStudentId) {
      this.toggleModal();
      this.studentIdsToMarkAsNoMatches = stateStudentId
        ? [stateStudentId] : [...this.match.students.map(s => s.stateStudentId)];
      try {
        await axios.put(`/directmatch/address/pending/${this.match.id}`, ({
          matchTypeId: this.matchTypeId,
          studentIdsToMarkAsNoMatches: this.studentIdsToMarkAsNoMatches,
          command: 'MARK_IDS',
        }));
        this.showNotification('success', ['"No Match" decision has been made for the record']);
      } catch (error) {
        const { status } = error.response;
        let apiMsg = '';

        if (status === 500) {
          apiMsg = 'Network Error';
        } else if (status === 400) {
          apiMsg = 'Something went wrong.';
        } else {
          apiMsg = `${error.response.data.message}`;
        }
        this.showNotification('danger', [apiMsg]);
      }
      this.$emit('refresh');
    },
  },
  filters: {
    formatDate(value) {
      if (value) {
        return moment(value).format('MM/DD/YYYY');
      }
      return null;
    },
  },
};

</script>

<style lang="sass" scoped>
  .document
    // max-width: 1168px
    margin-bottom: 1rem !important
    font-size: .85rem
  .card-container
    padding: .5rem 1rem
  .match-icon
    margin-right: 1rem
  .columns
    margin: 0
    height: 100%
    .column
      padding: 0 .5rem
      min-height: 75px
      .column-container
        display: flex
        flex-direction: row
        justify-content: center
        height: 100%
        .block
          display: flex
          flex-direction: column
          justify-content: center
          align-items: flex-start
          height: 100%
        .percent-match
          padding-right: 1rem
  .card-title-container
    display: flex
  .column-icons
    display: flex
    align-items: center
  .actions
    align-items: center
    display: inline-flex
    padding-left: 2rem
    padding-right: 1rem
  .icon-spacing
    margin-right: .75rem
  .students-header
    border-bottom: 1px solid #DEE2e6
    padding-bottom: 0.5rem
  .students-block
    padding: 1.5rem 4rem

  .align-left
    justify-content: flex-start !important
  .align-right
    justify-content: flex-end !important
  .has-border
    border-left: 1px solid  rgb(222, 226, 230)
  .fullwidth
    width: 100%
  .percent-label
    font-style: bold
    color: black
    font-size: 1.1rem
    font-weight: 800
    padding: .25rem 0 .25rem .15rem
</style>
